import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { ChatWidget } from "../ChatWidget";
import { SmoothScroll } from "../SmoothScroll";
import { useLanguage } from "../../context/LanguageContext";

export const Layout = () => {
  const { pathname } = useLocation();
  const { content } = useLanguage();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    if (content.seo?.title) document.title = content.seo.title;
    const meta = document.querySelector('meta[name="description"]');
    if (meta && content.seo?.description) meta.setAttribute("content", content.seo.description);
  }, [content]);

  return (
    <SmoothScroll>
      <div className="App relative min-h-screen bg-brand-beige">
        <Navbar />
        <main>
          <Outlet />
        </main>
        <Footer />
        <ChatWidget />
      </div>
    </SmoothScroll>
  );
};
